import styled from 'styled-components';

export const Consignment = styled.div`
  display: flex;
  gap: 16px;
`;
